export default __webpack_public_path__ + "static/subset-UniNeueThin-5a038933cdab8ee4e76b11dc9159bb97.woff2";